var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getQuestionComponent(_vm.questionType),{tag:"component",attrs:{"question":_vm.questionEmbedded,"isTaskReadOnly":_vm.readOnly},on:{"input":function($event){return _vm.onAnsweringQuestion($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }